export default __webpack_public_path__ + "static/media/close_dark.2389ac8e.svg";